import { defineStore, acceptHMRUpdate } from 'pinia'
import { LAYOUT_DEFAULT } from '@/utils/constance'

export const useAppStore = defineStore({
  id: 'app',
  state: () => ({
    // 布局模式
    layoutMode: LAYOUT_DEFAULT,
    // 侧边菜单宽度(展开时)，单位px
    menuWidth: '260px',
    // 侧边菜单项默认图标
    menuDefaultIcon: '',
    // 是否水平折叠收起菜单
    menuCollapse: false,
    // 是否只保持一个子菜单的展开(手风琴)
    menuUniqueOpened: false,
    // 显示菜单栏顶栏(LOGO)
    menuShowTopBar: true,
    // 是否为移动端
    isMobile: false,
    lastChapterProps: null
  }),
  actions: {
    setLayoutMode (mode) {
      this.layoutMode = mode
    },
    setIsMobile (isMobile) {
      this.isMobile = isMobile
    },
    setLastChapterProps (lastChapterProps) {
      this.lastChapterProps = lastChapterProps
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
